import { getElements } from "js-utils/src/selector"
import VimeoPlayer from "@vimeo/player"
import _ from "underscore"
import init from "../base/init"

const selectVideo = (newVimeoId) => {
  const player = document.querySelector(".course-analysis-video-player")
  const vimeoIframeEl = player.querySelector("iframe")
  vimeoIframeEl.src = `https://player.vimeo.com/video/${newVimeoId}?title=0&byline=0&portrait=0`
  vimeoIframeEl.dataset.vimeoId = newVimeoId
}

const initVideoPlayer = (videoItemEl, initialVideo) => {
  console.log("initVideoPlayer")
  const player = document.querySelector(".course-analysis-video-player")
  const video = player
  let activeSection = 0, sectionTimes = []
  let currentTime = parseInt(video.getAttribute("data-video-current-time"))
  const playVideoButtons = getElements(".play-video")
  const vimeoPlayer = new VimeoPlayer(player.querySelector("iframe"))
  const videoSections = videoItemEl.querySelectorAll(".video-sections__inner-wrapper li")
  const mobileToggler = videoItemEl.querySelector(".video-sections__expander")
  let sectionsOpen = false
  const video_type = window.LEXNOVA.aet.props.available_to_user === "true" ? "video" : "trailer"
  const videoDuration = vimeoPlayer.getDuration()

  const eventListeners = []

  const addEventListener = (element, event, handler) => {
    if (!element.addEventListener) {
      console.error("Element does not support addEventListener")
      return
    }
    element.addEventListener(event, handler)
    eventListeners.push({ element, event, handler })
  }

  const removeEventListeners = () => {
    eventListeners.forEach(({ element, event, handler }) => {
      element.removeEventListener(event, handler)
    })
  }

  vimeoPlayer.setColor("#d61368")

  if (currentTime) {
    vimeoPlayer.setCurrentTime(currentTime)
  }

  playVideoButtons.forEach((button) => {
    addEventListener(button, "click", () => {
      player.classList.add("video-player--overlay-hidden")
      vimeoPlayer.play()

      window.dispatchEvent(new CustomEvent("AET", {
        detail: {
          name: `${window.LEXNOVA.section_name}.${video_type}_play`,
          props: window.LEXNOVA.aet.props,
        },
      }))
    })
  })

  vimeoPlayer.on("ended", () => {
    videoEvent({ event: "ended", type: video_type })
    player.classList.remove("video-player--overlay-hidden")
    player.classList.remove("video-player--playing")

    window.dispatchEvent(new CustomEvent("AET", {
      detail: {
        name: `${window.LEXNOVA.section_name}.${video_type}_finished`,
        props: window.LEXNOVA.aet.props,
      },
    }))
  })

  vimeoPlayer.on("play", () => {
    videoEvent({ event: "play", type: video_type })
    player.classList.add("video-player--playing")

    window.dispatchEvent(new CustomEvent("AET", {
      detail: {
        name: `${window.LEXNOVA.section_name}.${video_type}_play`,
        props: window.LEXNOVA.aet.props,
      },
    }))
  })

  vimeoPlayer.on("pause", (data) => {
    videoEvent({ event: "pause", seconds: data.seconds, type: video_type })
    player.classList.remove("video-player--playing")

    window.dispatchEvent(new CustomEvent("AET", {
      detail: {
        name: `${window.LEXNOVA.section_name}.${video_type}_pause`,
        props: window.LEXNOVA.aet.props,
      },
    }))
  })

  vimeoPlayer.on("timeupdate", (data) => {
    videoEvent({ event: "progress", seconds: data.seconds, type: video_type })

    if (getElements(".quiz.is-hidden").length > 0) {
      // Add cue point for showing quiz at 90%
      videoDuration.then((time) => {
        if (currentTime > parseInt(time * 0.9)) {
          showQuiz()
        }
      })
    }
  })

  const fireVideoEvent = (dataObject) => {
    // User#do_not_track must be set to false
    if (video_type === "video") {
      fetch("/api/v1/playbacks/" + video.getAttribute("data-video-resource-id"), {
        method: "PATCH",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify(dataObject),
      })
    }
  }

  const videoEvent = _.throttle(
    fireVideoEvent, 5000
  )

  const sectionProgress = () => {
    let progress = ((currentTime - sectionTimes[activeSection][0]) / (sectionTimes[activeSection][1] - sectionTimes[activeSection][0])) * 100
    videoItemEl.querySelectorAll(".video-sections__inner-wrapper li")[activeSection].firstElementChild.style.width = progress + "%"
  }

  const adjustActiveSection = () => {
    sectionTimes.map((i, index) => {
      if (currentTime > i[0] && currentTime < i[1]) {
        activeSection = index

        videoSections.forEach((item) => {
          item.classList.remove("active")
        })

        videoSections[activeSection].classList.add("active")
      }
    })
  }

  // if we can access full video then we also allow navigation in sections
  if (!getElements(".video-player--access-false").length > 0) {

    if (!videoSections.length) return

    vimeoPlayer.on("timeupdate", (data) => {
      currentTime = data.seconds
      adjustActiveSection()
      sectionProgress()
    })

    videoSections.forEach((item) => {

      let timesArray = []
      timesArray.push(parseInt(item.getAttribute("data-timestart")))
      timesArray.push(parseInt(item.getAttribute("data-timeend")))
      sectionTimes.push(timesArray)

      addEventListener(item, "click", () => {
        currentTime = parseInt(item.getAttribute("data-timestart"))
        if (currentTime) {
          vimeoPlayer.setCurrentTime(currentTime)
        }

        player.classList.add("video-player--overlay-hidden")
        vimeoPlayer.play()

        videoSections.forEach((item) => {
          item.classList.remove("active")
        })

        item.classList.add("active")
      })
    })
  }

  if (initialVideo) {
    setTimeout(() => {
      const sectionVideosContainerEl = videoItemEl.querySelector(`.video-sections`);
      const sectionInnerContentEl = videoItemEl.querySelector(`.video-sections__inner-wrapper`);
      const sectionInnerContentScrollHeight = sectionInnerContentEl.scrollHeight;
      sectionVideosContainerEl.style.height = `${sectionInnerContentScrollHeight}px`;
    }, 200)
  }

  // sections toggle on mobile
  const videoSectionsContainer = videoItemEl.querySelector(".video-sections__list-wrapper")

  const toggleSections = () => {

    if (!videoSectionsContainer.length) return

    videoSectionsContainer.style.height = videoSectionsContainer.firstElementChild.offsetHeight + "px"
    videoSectionsContainer.classList.toggle("open")
    mobileToggler.classList.toggle("open")

    if (sectionsOpen) {
      window.requestAnimationFrame(() => {
        videoSectionsContainer.style.height = 0
      })
      sectionsOpen = false
    } else {
      sectionsOpen = true
    }
  }

  if (videoSectionsContainer) {
    addEventListener(videoSectionsContainer, "transitionend", () => {
      if (sectionsOpen) {
        videoSectionsContainer.style.height = "auto"
      } else {
        videoSectionsContainer.removeAttribute("style")
      }
    })
  }

  if (mobileToggler) {
    addEventListener(mobileToggler, "click", () => {
      toggleSections()
    })
  }

  const showQuiz = () => {
    getElements(".quiz.is-hidden")[0].classList.remove("is-hidden")
  }

  return () => {
    removeEventListeners()
    video.setAttribute("data-video-current-time", "0")
    vimeoPlayer.off("ended");
    vimeoPlayer.off("play");
    vimeoPlayer.off("pause");
    vimeoPlayer.off("timeupdate");
  }
}

const setLoading = (loading) => {
  const videoItemEls = document.querySelectorAll(".course-analysis-video-sections")
  Array.prototype.forEach.call(videoItemEls, (el) => {
    el.style.opacity = loading ? 0.5 : 1
  })
}

init(() => {
  let video = document.getElementsByClassName("course-analysis-video-player")
  if (!video.length) return

  const videoItemEls = document.querySelectorAll(".course-analysis-video-sections")
  const vimeoIframeEl = document.querySelector(".video-player iframe")
  let cleanUpCb = null

  Array.prototype.forEach.call(videoItemEls, (el) => {
    const btnEl = el.querySelector('.course-analysis-video-sections__video');
    btnEl.addEventListener("click", function() {
      if (vimeoIframeEl.dataset.vimeoId === btnEl.dataset.vimeoVideoId) {
        return
      }

      if (cleanUpCb) {
        cleanUpCb()
      }

      Array.prototype.forEach.call(videoItemEls, (el) => {
        el.style.height = "56px";
        el.classList.remove('-active');
      })

      const sectionVideosContainerEl = btnEl.parentNode.querySelector(`.video-sections`);
      const sectionInnerContentEl = btnEl.parentNode.querySelector(`.video-sections__inner-wrapper`);
      const sectionInnerContentScrollHeight = sectionInnerContentEl.scrollHeight;

      el.style.height = "auto";
      el.classList.add('-active');
      sectionVideosContainerEl.style.height = `${sectionInnerContentScrollHeight}px`;

      setLoading(true);
      selectVideo(btnEl.dataset.vimeoVideoId)
      setTimeout(() => {
        cleanUpCb = initVideoPlayer(el, false)
        setLoading(false);
      }, 1000)
    })
  })

  cleanUpCb = initVideoPlayer(videoItemEls[0], true)
})
